/*
 * Jira Ticket:
 * Created Date: Tue, 12th May 2020, 11:00:23 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const exportTowerPDFMutation = gql`
  mutation ExportTowerPDF($id: ID!) {
    data: exportTowerPDF(id: $id) {
      downloadUrl
    }
  }
`;

export default async ({ client, params }) => {
  try {
    return client.mutate({
      mutation: exportTowerPDFMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
